<div mat-dialog-title class="dialog-header">
    <span
        class="x-circle"
        hamIconShapes
        icon="assets/hamIcons/x-circle.svg"
        [variant]="'transparent'"
        [size]="'lg'"
        (click)="closeDialog()"
    ></span>
</div>

<div class="container dialog-content">
    <form [formGroup]="formGroup">
        <div class="form-field-row">
            <div class="form-field">
                <aum-input
                    placeholder="{{ 'aumico_templates_group_account_mapping_create_group_form_name' | i18next  }}"
                    [aumFormControl]="formGroup.controls['name']"
                >
                    <aum-form-field-label>
                        {{ 'aumico_templates_group_account_mapping_create_group_form_name_label' | i18next }}
                    </aum-form-field-label>
                    <aum-form-error
                        *ngIf="
                            formGroup.controls['name'].touched &&
                            formGroup.controls['name'].hasError('required')
                        "
                    >
                        <span>
                            {{ 'aumico_templates_group_account_mapping_create_group_form_name_required_error' | i18next
                            }}
                        </span>
                    </aum-form-error>
                    <aum-form-error *ngIf="formGroup.controls['name'].hasError('nameAlreadyExists')">
                        {{ 'aumico_templates_group_account_mapping_create_group_form_name_already_exists_error' |
                        i18next }}
                    </aum-form-error>
                </aum-input>
            </div>
            <div>
                <aum-input
                    placeholder="{{ 'aumico_templates_group_account_mapping_create_group_form_total_name' | i18next  }}"
                    [aumFormControl]="formGroup.controls['totalName']"
                >
                    <aum-form-field-label>
                        {{ 'aumico_templates_group_account_mapping_create_group_form_total_name_label' | i18next }}
                    </aum-form-field-label>
                    <aum-form-error
                        *ngIf="formGroup.controls['totalName'].touched && formGroup.controls['totalName'].invalid"
                    >
                        <span>
                            {{ 'aumico_templates_group_account_mapping_create_group_form_total_name_required_error' |
                            i18next }}
                        </span>
                    </aum-form-error>
                </aum-input>
            </div>
            <div>
                <aum-select
                    placeholder="{{ 'aumico_templates_group_account_mapping_create_group_form_fli_options' | i18next }}"
                    [options]="data.financialLineItemsOptions"
                    [aumFormControl]="formGroup.controls['financialLineItems']"
                    [multiple]="true"
                >
                    <aum-form-field-label>
                        {{ 'aumico_templates_group_account_mapping_create_group_form_fli_options_label' | i18next }}
                    </aum-form-field-label>
                </aum-select>
            </div>
        </div>
    </form>
</div>
<div class="actions-footer">
    <mat-dialog-actions>
        <button aum-button (click)="onSaveClicked()" color="primary" [disabled]="formGroup == null || formGroup.invalid">
            {{ 'aumico_templates_group_account_mapping_create_group_form_button' | i18next }}
        </button>
    </mat-dialog-actions>
</div>
